import { render, staticRenderFns } from "./DebtDetails.vue?vue&type=template&id=647078be&"
import script from "./DebtDetails.vue?vue&type=script&lang=js&"
export * from "./DebtDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports